import apiClient from './client';

interface SignupPayload {
  first_name: string;
  last_name: string;
  email: string;
}

export const authApi = {
  requestPasswordReset: (email: string) =>
    apiClient.post('/auth/forgot-password', { email }).then((res) => res.data),

  resetPassword: (token: string, password: string) =>
    apiClient.post('/auth/reset-password', { token, password }).then((res) => res.data),

  loginWithPassword: (email: string, password: string) =>
    apiClient.post('/auth/login-password', { email, password }).then((res) => res.data),

  sendMagicLink: (email: string) =>
    apiClient.post('/auth/magic-link', { email }).then((res) => res.data),

  signup: (payload: SignupPayload) =>
    apiClient.post('/auth/signup', payload).then((res) => res.data),

  verifyEmail: (token: string) =>
    apiClient.get('/auth/verify-email', { params: { token } }).then((res) => res.data),

  setPassword: (password: string) =>
    apiClient.post('/auth/set-password', { password }).then((res) => res.data),

  getProfile: () => apiClient.get('/user/profile').then((res) => res.data),

  logout: () => apiClient.post('/auth/logout').catch(() => {}),
};

